/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as OrgSlugRouteImport } from './routes/$orgSlug'
import { Route as IndexRouteImport } from './routes/index'
import { Route as OrgSlugIndexRouteImport } from './routes/$orgSlug/index'
import { Route as RemixSlugRouteImport } from './routes/remix/$slug'
import { Route as OrgSlugDiscoverRouteImport } from './routes/$orgSlug/discover'
import { Route as OrgSlugTeamsIndexRouteImport } from './routes/$orgSlug/teams/index'
import { Route as OrgSlugProjectsIndexRouteImport } from './routes/$orgSlug/projects/index'
import { Route as OrgSlugTeamsTeamIdRouteImport } from './routes/$orgSlug/teams/$teamId'
import { Route as OrgSlugProjectsProjectIdRouteImport } from './routes/$orgSlug/projects/$projectId'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgSlugRoute = OrgSlugRouteImport.update({
  id: '/$orgSlug',
  path: '/$orgSlug',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgSlugIndexRoute = OrgSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrgSlugRoute,
} as any)
const RemixSlugRoute = RemixSlugRouteImport.update({
  id: '/remix/$slug',
  path: '/remix/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgSlugDiscoverRoute = OrgSlugDiscoverRouteImport.update({
  id: '/discover',
  path: '/discover',
  getParentRoute: () => OrgSlugRoute,
} as any)
const OrgSlugTeamsIndexRoute = OrgSlugTeamsIndexRouteImport.update({
  id: '/teams/',
  path: '/teams/',
  getParentRoute: () => OrgSlugRoute,
} as any)
const OrgSlugProjectsIndexRoute = OrgSlugProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => OrgSlugRoute,
} as any)
const OrgSlugTeamsTeamIdRoute = OrgSlugTeamsTeamIdRouteImport.update({
  id: '/teams/$teamId',
  path: '/teams/$teamId',
  getParentRoute: () => OrgSlugRoute,
} as any)
const OrgSlugProjectsProjectIdRoute =
  OrgSlugProjectsProjectIdRouteImport.update({
    id: '/projects/$projectId',
    path: '/projects/$projectId',
    getParentRoute: () => OrgSlugRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$orgSlug': typeof OrgSlugRouteWithChildren
  '/login': typeof LoginRoute
  '/$orgSlug/discover': typeof OrgSlugDiscoverRoute
  '/remix/$slug': typeof RemixSlugRoute
  '/$orgSlug/': typeof OrgSlugIndexRoute
  '/$orgSlug/projects/$projectId': typeof OrgSlugProjectsProjectIdRoute
  '/$orgSlug/teams/$teamId': typeof OrgSlugTeamsTeamIdRoute
  '/$orgSlug/projects': typeof OrgSlugProjectsIndexRoute
  '/$orgSlug/teams': typeof OrgSlugTeamsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/$orgSlug/discover': typeof OrgSlugDiscoverRoute
  '/remix/$slug': typeof RemixSlugRoute
  '/$orgSlug': typeof OrgSlugIndexRoute
  '/$orgSlug/projects/$projectId': typeof OrgSlugProjectsProjectIdRoute
  '/$orgSlug/teams/$teamId': typeof OrgSlugTeamsTeamIdRoute
  '/$orgSlug/projects': typeof OrgSlugProjectsIndexRoute
  '/$orgSlug/teams': typeof OrgSlugTeamsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$orgSlug': typeof OrgSlugRouteWithChildren
  '/login': typeof LoginRoute
  '/$orgSlug/discover': typeof OrgSlugDiscoverRoute
  '/remix/$slug': typeof RemixSlugRoute
  '/$orgSlug/': typeof OrgSlugIndexRoute
  '/$orgSlug/projects/$projectId': typeof OrgSlugProjectsProjectIdRoute
  '/$orgSlug/teams/$teamId': typeof OrgSlugTeamsTeamIdRoute
  '/$orgSlug/projects/': typeof OrgSlugProjectsIndexRoute
  '/$orgSlug/teams/': typeof OrgSlugTeamsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$orgSlug'
    | '/login'
    | '/$orgSlug/discover'
    | '/remix/$slug'
    | '/$orgSlug/'
    | '/$orgSlug/projects/$projectId'
    | '/$orgSlug/teams/$teamId'
    | '/$orgSlug/projects'
    | '/$orgSlug/teams'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/$orgSlug/discover'
    | '/remix/$slug'
    | '/$orgSlug'
    | '/$orgSlug/projects/$projectId'
    | '/$orgSlug/teams/$teamId'
    | '/$orgSlug/projects'
    | '/$orgSlug/teams'
  id:
    | '__root__'
    | '/'
    | '/$orgSlug'
    | '/login'
    | '/$orgSlug/discover'
    | '/remix/$slug'
    | '/$orgSlug/'
    | '/$orgSlug/projects/$projectId'
    | '/$orgSlug/teams/$teamId'
    | '/$orgSlug/projects/'
    | '/$orgSlug/teams/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  OrgSlugRoute: typeof OrgSlugRouteWithChildren
  LoginRoute: typeof LoginRoute
  RemixSlugRoute: typeof RemixSlugRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$orgSlug': {
      id: '/$orgSlug'
      path: '/$orgSlug'
      fullPath: '/$orgSlug'
      preLoaderRoute: typeof OrgSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$orgSlug/': {
      id: '/$orgSlug/'
      path: '/'
      fullPath: '/$orgSlug/'
      preLoaderRoute: typeof OrgSlugIndexRouteImport
      parentRoute: typeof OrgSlugRoute
    }
    '/remix/$slug': {
      id: '/remix/$slug'
      path: '/remix/$slug'
      fullPath: '/remix/$slug'
      preLoaderRoute: typeof RemixSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$orgSlug/discover': {
      id: '/$orgSlug/discover'
      path: '/discover'
      fullPath: '/$orgSlug/discover'
      preLoaderRoute: typeof OrgSlugDiscoverRouteImport
      parentRoute: typeof OrgSlugRoute
    }
    '/$orgSlug/teams/': {
      id: '/$orgSlug/teams/'
      path: '/teams'
      fullPath: '/$orgSlug/teams'
      preLoaderRoute: typeof OrgSlugTeamsIndexRouteImport
      parentRoute: typeof OrgSlugRoute
    }
    '/$orgSlug/projects/': {
      id: '/$orgSlug/projects/'
      path: '/projects'
      fullPath: '/$orgSlug/projects'
      preLoaderRoute: typeof OrgSlugProjectsIndexRouteImport
      parentRoute: typeof OrgSlugRoute
    }
    '/$orgSlug/teams/$teamId': {
      id: '/$orgSlug/teams/$teamId'
      path: '/teams/$teamId'
      fullPath: '/$orgSlug/teams/$teamId'
      preLoaderRoute: typeof OrgSlugTeamsTeamIdRouteImport
      parentRoute: typeof OrgSlugRoute
    }
    '/$orgSlug/projects/$projectId': {
      id: '/$orgSlug/projects/$projectId'
      path: '/projects/$projectId'
      fullPath: '/$orgSlug/projects/$projectId'
      preLoaderRoute: typeof OrgSlugProjectsProjectIdRouteImport
      parentRoute: typeof OrgSlugRoute
    }
  }
}

interface OrgSlugRouteChildren {
  OrgSlugDiscoverRoute: typeof OrgSlugDiscoverRoute
  OrgSlugIndexRoute: typeof OrgSlugIndexRoute
  OrgSlugProjectsProjectIdRoute: typeof OrgSlugProjectsProjectIdRoute
  OrgSlugTeamsTeamIdRoute: typeof OrgSlugTeamsTeamIdRoute
  OrgSlugProjectsIndexRoute: typeof OrgSlugProjectsIndexRoute
  OrgSlugTeamsIndexRoute: typeof OrgSlugTeamsIndexRoute
}

const OrgSlugRouteChildren: OrgSlugRouteChildren = {
  OrgSlugDiscoverRoute: OrgSlugDiscoverRoute,
  OrgSlugIndexRoute: OrgSlugIndexRoute,
  OrgSlugProjectsProjectIdRoute: OrgSlugProjectsProjectIdRoute,
  OrgSlugTeamsTeamIdRoute: OrgSlugTeamsTeamIdRoute,
  OrgSlugProjectsIndexRoute: OrgSlugProjectsIndexRoute,
  OrgSlugTeamsIndexRoute: OrgSlugTeamsIndexRoute,
}

const OrgSlugRouteWithChildren =
  OrgSlugRoute._addFileChildren(OrgSlugRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  OrgSlugRoute: OrgSlugRouteWithChildren,
  LoginRoute: LoginRoute,
  RemixSlugRoute: RemixSlugRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
